import { Button } from "../../../../../core/components/atoms/Button"
import { Typography } from "../../../../../core/components/molecules/Typography"
import { Modal } from "../../../../../core/components/templates/Modal"
import { useMemo } from "react"
import { IDisciplineSubject } from "../../../model/disciplineSubjects"

interface ModalConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  loadingAdd: boolean;
  handleConfirmation: () => void;
  subjects?: IDisciplineSubject[];
  selectedSubjects?: string[];
}

const ModalConfirmation = ({
  isOpen,
  onClose,
  loadingAdd,
  handleConfirmation,
  subjects,
  selectedSubjects = []
}: ModalConfirmationProps) => {
  const selectedSubjectsData = useMemo(() => {
    if (!subjects || selectedSubjects.length === 0) {
      return [];
    }

    const allSubjects: Array<{
      id: string;
      title: string;
      totalVideoaulas: number;
      totalExercicios: number;
      totalMaterias: number;
    }> = [];

    subjects.forEach((module) => {
      module.subjects.forEach((subject) => {
        if (selectedSubjects.includes(subject.subjectId)) {
          allSubjects.push({
            id: subject.id,
            title: subject.title,
            totalVideoaulas: subject.totalVideoaulas,
            totalExercicios: subject.totalExercicios,
            totalMaterias: subject.totalMaterias,
          });
        }
      });
    });

    return allSubjects;
  }, [subjects, selectedSubjects]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title='Adicionar Assuntos'
      className={'max-w-[550px]'}
      position='center'
    >
      <div className='flex flex-col gap-lg'>
        <Typography weight='bold'>
          Você tem certeza que gostaria de adicionar os Assuntos selecionados?
        </Typography>
        <div className='flex flex-col gap-md'>
          {selectedSubjectsData.map((subject) => (
            <div key={subject.id}>
              <Typography weight='bold' size={'small'}>{subject.title}</Typography>
              <ul className='ml-5 list-disc text-sm text-mono-color-darker'>
                <li>{subject.totalVideoaulas} videoaulas</li>
                <li>{subject.totalExercicios} exercícios</li>
                <li>{subject.totalMaterias} materiais</li>
              </ul>
            </div>
          ))}
        </div>
        <div className='flex items-center justify-between gap-lg border-t-hairline border-mono-color-light pt-4'>
          <div className='w-1/2'>
            <Button variant='text' full onClick={onClose}>
              Cancelar
            </Button>
          </div>
          <div className='w-1/2'>
            <Button
              variant='contained'
              full
              onClick={handleConfirmation}
              loading={loadingAdd}
            >
              Adicionar
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalConfirmation;